// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__16U--","logo":"Home_logo__1psfd","inspire":"Home_inspire__3M0ji","quoteContainer":"Home_quoteContainer__2xKFt","quoteIcon":"Home_quoteIcon__357E0"};